import { __rest } from "tslib";
import React from 'react';
import styles from './Button.module.scss';
import { combineClassNames } from '../../../util/css/classNames.js';
export const Button = (_a) => {
    var { children, color, className } = _a, nativeProps = __rest(_a, ["children", "color", "className"]);
    return (React.createElement("button", Object.assign({ className: combineClassNames(styles.container, color === 'white-on-orange' && styles.colorWhiteOnOrange, color === 'orange-on-white' && styles.colorOrangeOnWhite, className) }, nativeProps), children));
};
